
<div class="histogram">
    <div class="inner" :style="{ height: height + 'px' }">
        <div
            class="d-flex justify-content-between h-100 align-items-end x-axis"
        >
            <div
                v-for="(n, i) in data"
                :key="'value-' + i"
                class="histogram-column"
                :style="{ height: columnHeight(n.value) }"
                v-b-tooltip.hover
                :title="n.value"
            >
                <div class="histogram-label numeric">
                    <span>{{ n.label }}</span>
                </div>
            </div>
        </div>

        <div class="y-axis align-top numeric">
            <table class="h-100 histogram-label">
                <tr>
                    <td class="align-top" v-if="max">{{ max }}</td>
                </tr>
                <tr>
                    <td class="align-middle" v-if="max">{{ max / 2 }}</td>
                </tr>
                <tr>
                    <td class="align-bottom">0</td>
                </tr>
            </table>
        </div>
    </div>
</div>
